import { Modal } from 'antd';
import clsx from 'classnames';
import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import gpsIcon from '../../assets/icons/gps_icon.svg';
import sensorIcon from '../../assets/icons/sensor_icon.svg';
import speakerIcon from '../../assets/icons/speaker_icon.svg';
import faceTerminalIcon from '../../assets/icons/face_terminal_icon.svg';

import { useDispatch, useSelector } from 'react-redux';
import { AddRemoteSensorComponent } from './AddRemoteSensor';

import AddAndEditRemoteSpeaker from './AddAndEditRemoteSpeaker';
import { AddGpsComponent } from './AddRemoteGps';
import './index.scss';
import AddFaceTerminalComponent from './AddRemoteFaceTerminal';
export const AddRemoteDevice = ({
  isOpen,
  onClose,
  onAddRemote,
  onCheckExternalDevice,
  onUpdateRemote,
  handleOnAddCameraDone,
  gatewaySerial,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { checkExternalDevice, activeDeviceData } = useSelector(
    (state) => state
  );

  const [selectedType, setSelectedType] = useState();
  const [checkExternalDeviceReturn, setCheckExternalDeviceReturn] = useState();
  const [activeDeviceReturn, setActiveDeviceReturn] =
    useState(activeDeviceData);

  const LIST_DEVICES = [
    {
      title: t('Sensor'),
      icon: sensorIcon,
      key: 'sensor',
    },
    {
      title: t('Speaker'),
      icon: speakerIcon,
      key: 'speaker',
    },
    {
      title: t('GPS'),
      icon: gpsIcon,
      key: 'gps',
    },
    {
      title: t('Face terminal'),
      icon: faceTerminalIcon,
      key: 'face_terminal',
    }
  ];

  useEffect(() => {
    return () => {
      setCheckExternalDeviceReturn(null);
      setActiveDeviceReturn(null);
    };
  }, []);

  useEffect(() => {
    setCheckExternalDeviceReturn(checkExternalDevice);
  }, [checkExternalDevice]);

  return (
    <Fragment>
      <Modal
        visible={isOpen}
        onCancel={onClose}
        title={t('Select type of device')}
        footer={null}
      >
        <div className="choose-remote-device-wrapper">
          {LIST_DEVICES.map((item) => {
            return (
              <div
                key={item.key}
                className={clsx('device-item', {
                  selected: selectedType === item.key,
                })}
                onClick={() => {
                  setSelectedType(item.key);
                  onClose();
                }}
              >
                <img className="device-icon" src={item.icon} alt={item.title} />
                <div>{item.title}</div>
              </div>
            );
          })}
        </div>
      </Modal>

      {/* Modal add sensor */}
      <Modal
        title={t('Add new sensor')}
        visible={selectedType === 'sensor'}
        onCancel={() => {
          setSelectedType('');
        }}
        footer={null}
      >
        <AddRemoteSensorComponent
          dispatch={dispatch}
          checkDeviceReturn={checkExternalDeviceReturn}
          activeDeviceReturn={activeDeviceReturn}
          onCheckExternalDevice={onCheckExternalDevice}
          onAddRemote={onAddRemote}
          onUpdate={onUpdateRemote}
          handleAddSuccessful={() => {
            setSelectedType('');
            handleOnAddCameraDone();
          }}
        />
      </Modal>

      {/* Modal add speaker */}
      <AddAndEditRemoteSpeaker
        gatewaySerial={gatewaySerial}
        isOpen={selectedType === 'speaker'}
        onClose={() => setSelectedType('')}
        onUpdate={onUpdateRemote}
        handleAddSuccessful={() => {
          setSelectedType('');
          handleOnAddCameraDone();
        }}
      />
      <Modal
        title={t('Add new GPS')}
        visible={selectedType === 'gps'}
        onCancel={() => {
          setSelectedType('');
        }}
        footer={null}
      >
        <AddGpsComponent
          checkDeviceReturn={checkExternalDeviceReturn}
          activeDeviceReturn={activeDeviceReturn}
          gatewaySerial={gatewaySerial}
          onUpdate={onUpdateRemote}
          handleAddSuccessful={() => {
            setSelectedType('');
            handleOnAddCameraDone();
          }}
        />
      </Modal>
      {/* Modal add face terminal */}
      <Modal
        title={t('Add new Face terminal')}
        visible={selectedType === 'face_terminal'}
        onCancel={() => {
          setSelectedType('');
        }}
        footer={null}
      >
        <AddFaceTerminalComponent
          checkDeviceReturn={checkExternalDeviceReturn}
          gatewaySerial={gatewaySerial}
          onUpdate={onUpdateRemote}
          handleAddSuccessful={() => {
            setSelectedType('');
            // handleOnAddCameraDone();
          }}
          selectedType={selectedType}
        />
      </Modal>
    </Fragment>
  );
};

export default AddRemoteDevice;
